// Public guest-portal API: no Clerk session, authenticated by link + emailed one-time code.
import axios from 'axios';
import config from '../config';
import { absoluteApiUrl } from './drive';

const client = axios.create({ baseURL: config.apiUrl });
const data = (p) => p.then((r) => r.data);

const sessionKey = (token) => `guest:${token}`;

export const loadSession = (token) => {
  try { return sessionStorage.getItem(sessionKey(token)); } catch { return null; }
};
const saveSession = (token, session) => {
  try { sessionStorage.setItem(sessionKey(token), session); } catch { /* storage blocked */ }
};

const guestApi = (token, getSession) => {
  const headers = () => {
    const s = getSession();
    return s ? { 'X-Guest-Token': s } : {};
  };
  const base = `api/public/links/${token}/`;
  return {
    info: () => data(client.get(base, { headers: headers() })),
    requestCode: (email) => data(client.post(`${base}code/`, { email })),
    verify: async (body) => {
      const res = await data(client.post(`${base}verify/`, body));
      saveSession(token, res.session);
      return res.session;
    },
    contents: (folder) => data(client.get(`${base}contents/`, { headers: headers(), params: folder ? { folder } : {} })),
    downloadUrl: async (ids, inline = false) => {
      const { url } = await data(client.post(`${base}download/`, { ids, inline }, { headers: headers() }));
      return absoluteApiUrl(url);
    },
  };
};

export default guestApi;
